// eslint-disable-next-line import/no-unresolved
import * as Sentry from "@sentry/browser";
import localStorage from "./localStorage";

let tags = {};
window._nounConfig = window._nounConfig || {};
if (window._nounConfig.pluginHost) {
    tags = { pluginHost: window._nounConfig.pluginHost };
}

let sentryConfig = {
    dsn: window._nounConfig.sentryDSN,
    debug: window._nounConfig.debugMode,
    environment: window._nounConfig.environment,
    tags: tags,
    release: window._nounConfig.release,
    ignoreErrors: [
        "Cannot read property 'undefined' of undefined",
        "AMCore is not defined"
    ],
    maxMessageLength: 1000,
    allowUrls: [
        // eslint-disable-next-line no-useless-escape
        /static\.(test|staging|production)?\.?thenounproject\.com\/assets\/bundles\/[a-z0-9\-]*.js/
    ]
};

// Let exceptions from webpack files through to Sentry handling code in development
// but stop them from actually being sent in shouldSendCallback
if (process.env.NODE_ENV != "production") {
    sentryConfig.allowUrls.push(/webpack/);
}

const sentryDisabled = localStorage.getItem("DISABLE_JS_SENTRY");

if (
    sentryDisabled ||
    !window._nounConfig.sentryDSN ||
    window._nounConfig.environment === "dev"
) {
    console.warn("Sentry disabled.");
} else {
    Sentry.setTag(tags);
    Sentry.init(sentryConfig);
}

// Check error sending to Sentry
window._errorCheck = function() {
    Sentry.captureException(new Error("It worked!"));
    return true;
};

export default Sentry;
